import React, { Component } from "react";
import styled from "styled-components";

import { useTheme } from "../../hooks/";
import { StyledText } from "../common/basic";
import { ChevronRightArrow, PadlockIcon, RightArrowNew } from "../svgs";

const OfferCard = ({
  backgroundImage = "/myMTN.png",
  tag,
  title,
  description,
  onClick,
  lock,
  margin,
}) => {
  const { themeContext, theme } = useTheme();
  const { activeTheme } = themeContext;
  return (
    <Wrapper $margin={margin} onClick={() => onClick()}>
      {/*   */}
      {lock && (
        <LockCover>
          <CircularIconHolder>
            <PadlockIcon width={40} />
          </CircularIconHolder>
        </LockCover>
      )}
      <Image src={backgroundImage} />
      <Gradient>
        <CardDetails>
          <Body>
            <StyledText style={{ marginBlockEnd: 0 }} size={12} color={"white"}>
              {title}
            </StyledText>
            <StyledText size={6} color={"white"} style={{ width: "90%" }}>
              {description}
            </StyledText>
          </Body>
          {tag !== "" && (
            <Arrow color={theme.colors[themeContext.activeTheme]["background"]}>
              <ChevronRightArrow fill="#fff" width="10" />
            </Arrow>
          )}
        </CardDetails>
      </Gradient>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 150px;
  height: 150px;
  border-radius: 20px;
  margin: ${(props) => props.$margin || "10px"};
  /* display: inline-flex; */
  position: relative;
  /* box-shadow: 0 5px 4px rgba(0, 0, 0, 0.3);  */
`;

const LockCover = styled.div`
  position: absolute;
  z-index: 2;
  top: 0;
  right: 0;
  height: 150px;
  width: 150px;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const CircularIconHolder = styled.div`
  width: 70px;
  height: 70px;
  border-radius: 100px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Image = styled.img`
  width: 150px;
  height: 150px;
  position: absolute;
  border-radius: 20px;
`;
const Gradient = styled.div`
  width: 150px;
  height: 150px;
  border-radius: 20px;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.17) 39.58%,
    #000000 100%
  );
  position: relative;
  z-index: 1;
  display: grid;
  grid-auto-flow: column;
  align-items: flex-end;
`;
const Tag = styled.div`
  background-color: ${(prop) => prop.color};
  width: min-content;
  padding: 1px;
  margin-block-start: 0;
  margin-block-end: 0;
`;

const Body = styled.div`
  box-sizing: border-box;
  max-width: 210px;
  padding: 10px;
`;

const Arrow = styled.div`
  width: 17px;
  height: 17px;
  background-color: ${(prop) => prop.color};
  border-radius: 15px;
  position: absolute;
  bottom: 8px;
  right: 0;
  margin: 10px;
  justify-content: center;
  align-content: center;
  display: grid;
  flex: none;
`;

const CardDetails = styled.div``;

OfferCard.defaultProps = {
  tag: "Loyalty",
  title: "Pulse & Chill",
  description:
    "Just keep talking and browsing  to rack up points and you could be the winner! ",
};

export default OfferCard;
